import { useState, useEffect } from 'react';
import { Button, Modal, Form, InputGroup } from 'react-bootstrap';
import { ErrorSuccessAlertMessage } from '../errorSuccessMessage/ErrorSuccessAlertMessage';
import { AppConstants } from '../../constants/AppConstants';
import { ErrorMessages } from '../../constants/ErrorMessages';
import modalClass from '../cards/CompetitionsCards.module.css';
import formClass from '../../common/FormStyling.module.css';
import classes from './AskQuestionModal.module.css';
import { AiOutlineCheckCircle } from 'react-icons/ai';
import { BiLoaderAlt } from 'react-icons/bi';
import { DataService } from '../../services/DataService';
import callClass from './CallFeatureModal.module.css';

const CallFeatureModal = ({
  closeCallModal,
  organizedBy,
  learningActivityDetails,
}) => {
  const [studentQuery, setStudentQuery] = useState(AppConstants.emptyString);
  const [callingCode, setCallingCode] = useState('+91');
  const initialValues = { Name: '', mobileNumber: '', countryId: '91' };
  const [countriesList, setCountriesList] = useState([]);
  const [formValues, setFormValues] = useState(initialValues);
  const [showSubmitQuerySuccessMessage, setShowSubmitQuerySuccessMessage] =
    useState(AppConstants.falseText);
  const [mobileVerified, setMobileVerified] = useState(AppConstants.trueText);
  const [submitQueryError, setSubmitQueryError] = useState(
    AppConstants.emptyString
  );
  const [submitQuerySpinner, setSubmitQuerySpinner] = useState(
    AppConstants.falseText
  );
  const [nameError, setNameError] = useState('');
  const [phoneError, setPhoneError] = useState('');

  const validateMobileNumber = (event) => {
    let excludedKeywords = ['-', 'e', '+', 'E', '.', AppConstants.emptyString];
    if (excludedKeywords.includes(event.key)) event.preventDefault();
  };

  const validateForm = () => {
    return (
      formValues.Name.trim() &&
      formValues.mobileNumber.trim() &&
      !nameError &&
      !phoneError
    );
  };

  useEffect(() => {
    async function fetchCountries() {
      try {
        const url = AppConstants.fetchCountriesAPI;
        const response = await DataService.get(
          url,
          AppConstants.emptyString,
          AppConstants.emptyString
        );

        const india = response.find(
          (country) =>
            country.countryCallingCode === '+91' || country.name === 'India'
        );

        // const correctedCountries = response.map((country) => {
        //   if (country.id.toString() === '91') {
        //     return { ...country, id: 1, countryCallingCode: '+91' };
        //   }
        //   return country;
        // });

        const sortedCountries = [...response].sort((a, b) => {
          if (india && a.id === india.id) return -1;
          if (india && b.id === india.id) return 1;
          return 0;
        });

        setCountriesList(sortedCountries);

        const defaultCountry = india || sortedCountries[0];
        const defaultCountryId = defaultCountry?.id?.toString() || '1';
        const defaultCallingCode = defaultCountry?.countryCallingCode || '+91';

        // const india = sortedCountries.find((c) => c.id.toString() === '1') || {
        //   id: '1',
        //   name: 'India',
        //   countryCallingCode: '+91',
        // };

        setFormValues((prev) => ({
          ...prev,
          countryId: defaultCountryId,
        }));
        setCallingCode(defaultCallingCode);
      } catch (error) {
        setCountriesList([
          { id: '1', name: 'India', countryCallingCode: '+91' },
        ]);
        setFormValues((prev) => ({ ...prev, countryId: '1' }));
        setCallingCode('+91');
      }
    }
    fetchCountries();
  }, []);

  const validateName = (name) => {
    if (name.length < 3) {
      setNameError('Name must be at least 3 characters');
      return false;
    }
    if (name.length > 40) {
      setNameError('Name must be less than 40 characters');
      return false;
    }
    setNameError('');
    return true;
  };

  const validatePhone = (phone, countryId) => {
    const phoneRegex = countryId === '1' ? /^\d{10}$/ : /^\d{6,16}$/;

    if (!phoneRegex.test(phone)) {
      setPhoneError(
        countryId === '1'
          ? 'Please enter a valid 10-digit phone number'
          : 'Phone number must be 6-16 digits'
      );
      return false;
    }
    setPhoneError('');
    return true;
  };

  const submitQuestion = async () => {
    const isNameValid = validateName(formValues.Name);
    const isPhoneValid = validatePhone(formValues.mobileNumber);

    if (!isNameValid || !isPhoneValid) {
      return;
    }
    try {
      setSubmitQuerySpinner(true);
      const url = AppConstants.postLearningActivityInterestedLeadsApi;
      const selectedCountry = countriesList.find(
        (c) => c.id.toString() === formValues.countryId
      );
      const phoneNumberWithCode = `${selectedCountry.countryCallingCode} ${formValues.mobileNumber}`;

      const data = {
        query: studentQuery,
        activityId: learningActivityDetails.activityId,
        activityType: learningActivityDetails.activityType,
        name: formValues.Name,
        countryId: parseInt(formValues.countryId, 10),
        phoneNumber: formValues.mobileNumber,
        phoneNumberWithCode: phoneNumberWithCode,
      };
      const response = await DataService.post(
        url,
        data,
        AppConstants.emptyString,
        AppConstants.emptyString
      );

      if (response && response.ok) {
        setSubmitQuerySpinner(false);
        setShowSubmitQuerySuccessMessage(true);
        setStudentQuery(AppConstants.emptyString);
      } else {
        setSubmitQuerySpinner(false);
        setSubmitQueryError(ErrorMessages.studentCourseQuerySubmitError);
        let timer = setTimeout(() => {
          setSubmitQueryError(AppConstants.emptyString);
        }, AppConstants.messageDisappearTime);
        return () => {
          clearTimeout(timer);
        };
      }
    } catch (error) {
      setSubmitQuerySpinner(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'dob') {
      setFormValues({
        ...formValues,
        [name]: value?.replace(/(\d{4})-(\d{2})-(\d{2})/, '$1-$2-$3'),
      });
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
  };

  function handleMobileChange(e) {
    const value = e.target.value;
    const indianMobileRegex = /^\d{10}$/;
    if (formValues?.countryId === AppConstants.countryIdIndia) {
      if (indianMobileRegex.test(value)) {
        setMobileVerified(AppConstants.trueText);
      } else {
        setMobileVerified(AppConstants.trueText);
      }
    } else if (formValues?.countryId !== AppConstants.countryIdIndia) {
      if (
        value?.length >= AppConstants.nonIndianMinMobileNumber &&
        value?.length <= AppConstants.nonIndianMaxMobile
      ) {
        setMobileVerified(AppConstants.trueText);
      } else {
        setMobileVerified(AppConstants.trueText);
      }
    }
  }

  const handleModalClose = () => {
    setStudentQuery(AppConstants.emptyString);
    setShowSubmitQuerySuccessMessage(false);
    closeCallModal();
  };
  return (
    <div>
      <Modal
        show={true}
        onHide={handleModalClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header
          closeButton
          onHide={handleModalClose}
          className={modalClass.modalHeader}
        >
          <Modal.Title className={modalClass.modalTitle}>
            Request a Callback!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showSubmitQuerySuccessMessage ? (
            <div className={modalClass.modalBody}>
              <div className={modalClass.modalSuccessIcon}>
                <AiOutlineCheckCircle />
              </div>
              <div className={modalClass.modalAlertText}>
                Thank you {formValues.Name}
                <br></br>
                {organizedBy} will reach out to you soon.
              </div>
            </div>
          ) : (
            <>
              <p className={callClass.callGreetingText}>
                Submit your contact details, and <b>{organizedBy}</b> will call
                you shortly to provide personalized guidance on this{' '}
                {learningActivityDetails.activityType.toLowerCase()}.
              </p>
              <div className={classes.addQuestionsContainer}>
                <Form.Label className={formClass.formLabel}>
                  Name<span className="redAstrisk">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  minLength={3}
                  maxLength={40}
                  placeholder="Enter your name here"
                  value={formValues.Name}
                  name="Name"
                  required
                  className={`${formClass.formTextInput} ${nameError && 'is-invalid'}`}
                  min={0}
                  step={1}
                  onKeyUp={handleMobileChange}
                  onChange={(e) => {
                    handleChange(e);
                    validateName(e.target.value);
                  }}
                  onBlur={(e) => validateName(e.target.value)}
                />

                {nameError && (
                  <div className={callClass.feedback}>{nameError}</div>
                )}

                <Form.Label className={formClass.formLabel}>
                  Phone Number
                  <span className="redAstrisk">*</span>
                </Form.Label>
                <InputGroup className={callClass.InputGroupSection}>
                  <InputGroup.Text className={callClass.countryCode}>
                    <Form.Select
                      name="countryId"
                      value={formValues.countryId || '91'}
                      onChange={(e) => {
                        handleChange(e);
                        const selectedCountry = countriesList.find(
                          (country) => country.id.toString() === e.target.value
                        );
                        if (selectedCountry) {
                          setCallingCode(selectedCountry.countryCallingCode);
                        }
                        validatePhone(formValues.mobileNumber, e.target.value);
                      }}
                      className={callClass.countrySelect}
                    >
                      {countriesList.map((country) => (
                        <option key={country.id} value={country.id}>
                          {country.country} {country.countryCallingCode}
                        </option>
                      ))}
                    </Form.Select>
                  </InputGroup.Text>
                  <Form.Control
                    type="tel"
                    name="mobileNumber"
                    placeholder={
                      formValues.countryId === '91'
                        ? 'Enter 10-digit number'
                        : 'Enter your phone number'
                    }
                    className={`${phoneError && 'is-invalid'}`}
                    value={formValues.mobileNumber}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, '');
                      setFormValues({ ...formValues, mobileNumber: value });
                      validatePhone(value, formValues.countryId);
                    }}
                    maxLength={formValues.countryId === '91' ? 10 : 16}
                    onKeyUp={handleMobileChange}
                    onKeyDown={validateMobileNumber}
                    required
                  />
                </InputGroup>

                {phoneError && (
                  <div className={callClass.feedback}>{phoneError}</div>
                )}

                {/* <Form.Label className={formClass.formLabel}>Query</Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="Enter your query here"
                  className={formClass.formTextAreaInput}
                  value={studentQuery}
                  onChange={(e) => setStudentQuery(e.target.value)}
                /> */}
              </div>
            </>
          )}
          {submitQueryError && (
            <ErrorSuccessAlertMessage
              message={submitQueryError}
              varient={AppConstants.alertVarient[1]}
            />
          )}
        </Modal.Body>
        <Modal.Footer className={modalClass.modalFooter}>
          <Button onClick={handleModalClose} className={classes.modalBtn}>
            Close
          </Button>
          {!showSubmitQuerySuccessMessage && (
            <Button
              disabled={!validateForm() || submitQuerySpinner}
              onClick={submitQuestion}
              className={classes.modalBtn}
            >
              Submit{submitQuerySpinner && <BiLoaderAlt className="spinner" />}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CallFeatureModal;
